import { render, staticRenderFns } from "./ManuscriptFolderList.vue?vue&type=template&id=380ca5d0&scoped=true"
import script from "./ManuscriptFolderList.vue?vue&type=script&lang=ts"
export * from "./ManuscriptFolderList.vue?vue&type=script&lang=ts"
import style0 from "./ManuscriptFolderList.vue?vue&type=style&index=0&id=380ca5d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380ca5d0",
  null
  
)

export default component.exports